module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/campaign-three-a4bd15082f607b41dc1ad59acbe92b5a.png";